module.exports = __webpack_public_path__ + "img/emaapou6white.62e04e3e.svg";